import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getProductReviewsDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  productReviews: [
    {
      fieldName: "Name",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
    },
    {
      fieldName: "EPC ID",
      fieldValue: "epcId",
      className: "col-span-6",
      type: "text",
      name: "epcId",
      formType: "input",
      label: "EPC ID",
      placeholder: "Enter EPC ID",
      validation: { required: "EPC ID is required" },
    },
    {
        fieldName: "Brand Name",
        fieldValue: "brandName",
        className: "col-span-6",
        type: "text",
        name: "brandName",
        formType: "input",
        label: "Brand Name",
        placeholder: "Enter Brand Name",
        validation: { required: "Brand Name is required" },
    },
    {
      fieldName: "Category",
      fieldValue: "category",
      className: "col-span-6",
      type: "text",
      name: "category",
      formType: "input",
      label: "Category",
      placeholder: "Enter Category",
      validation: { required: "Category is required" },
    },
    {
      fieldName: "Product Name",
      fieldValue: "productName",
      className: "col-span-6",
      type: "text",
      name: "productName",
      formType: "input",
      label: "Product Name",
      placeholder: "Enter Product Name",
      validation: { required: "Product Name is required" },
    },
    // {
    //   fieldName: "Product Code",
    //   fieldValue: "productCode",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "productCode",
    //   formType: "input",
    //   label: "Product Code",
    //   placeholder: "Enter Product Code",
    //   validation: { required: "Product Code is required" },
    // },
    {
        fieldName: "Rating",
        fieldValue: "rating",
        className: "col-span-6",
        type: "text",
        name: "rating",
        formType: "select",
        label: "Rating",
        placeholder: "Enter Rating",
        validation: { required: "Rating is required" },
    },
    {
        fieldName: "Review Title",
        fieldValue: "title",
        className: "col-span-6",
        type: "text",
        name: "title",
        formType: "input",
        label: "Review Title",
        placeholder: "Enter Review Title",
        validation: { required: "Review Titleis required" },
      },
      {
          fieldName: "Description",
          fieldValue: "description",
          className: "col-span-6",
          type: "text",
          name: "description",
          formType: "select",
          label: "Description",
          placeholder: "Enter Description",
          validation: { required: "Description is required" },
      },
      {
        fieldName: "Attachment",
        fieldValue: "images",
        className: "col-span-6",
        type: "image",
        name: "images",
        formType: "file",
        label: "Attachment",
        placeholder: "Enter Attachment",
        validation: { required: "Attachment is required" },
      },
  ],
};
